import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function hyderabadPlant() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content">
                        <h2>Hyderabad Plant</h2>

                        <div class="row">
                          <div class="col-sm-6">
                            <img
                              src="../images/idplHyderabad.jpg"
                              class="img-responsive"
                            />
                          </div>
                          <div class="col-sm-6">
                            <div class="address">
                              <ul>
                                <li>
                                  <img src="../images/person.png" />{" "}
                                  <span>Contact Person Name : </span> Shri YRK
                                  Reddy
                                </li>
                                <li>
                                  <img src="../images/desi.png" />{" "}
                                  <span>Designation : </span>General
                                  Manager(Formulation)
                                </li>
                                <li>
                                  <img src="../images/home-icon.png" />{" "}
                                  <span>Address : </span> Balanagar,
                                  Hyderabad-500037 (Telangana)
                                </li>
                                <li>
                                  <img src="../images/cell_icon.gif" />{" "}
                                  <span>Telephone : </span>040-23078149,
                                </li>

                                <li>
                                  <img src="../images/fax.png" />
                                  <span> Fax No. : </span> 0040-23078144
                                </li>
                                <li>
                                  <img src="../images/mouse_icon.gif" />{" "}
                                  <span>E-mail : </span>
                                  yrkreddy.idplhyd@gmail.com
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <br />

                        <p>
                          Hyderabad plant is located at Balanagar / Kukatpally
                          in the heart of the city, 40 kms. away from
                          Rajivgandhi International Airport (Hyderabad), in
                          Telangana in 891 acres of land (3.61 million sq. mts).
                          The plant was commissioned in 1967 and manufactured
                          wide range of 47 bulk synthetic drugs like Vitamins,
                          Sulphas, Chloroquine, Methyl Dopa, Analgesics etc.
                          from basic stages.
                        </p>
                        <p>
                          Now, a "National Institute of Pharmaceutical Education
                          & Research (NIPER)"has been set-up on 19th October,
                          2007 at IDPL Research Center, offering training
                          programmes in all disciplines relating to pharmacy to
                          Graduate / Post Graduate students, thus providing
                          pharma experts to the growing needs of Indian Pharma
                          Industry.
                        </p>
                        <p>
                          Just 2 kms. away from the main plant, there is a well
                          developed township with 858 flats. The plant had
                          formulation facilities also, but at present the plant
                          operations are totally stopped since 1996(Bulk) and
                          2003 (Formulations). Only Effluent Treatment Plant,
                          (ETP) is being operated for treating effluents of
                          other industries.
                        </p>
                        <p>
                          In accordance with the decision of Govt. of India,
                          Department of Pharmaceuticals, to restart production,
                          a new formulation project is commissioned and
                          commercial production taken up.
                        </p>

                        <div class="clearfix"></div>

                        <div class="">
                          <iframe
                            src="https://www.google.com/maps/place/IDPL/@17.4719933,78.4306783,17z/data=!3m1!4b1!4m6!3m5!1s0x3bcb904be302bb39:0x4b41074966ff258e!8m2!3d17.4719882!4d78.4332586!16s%2Fg%2F1tgckrnb?entry=ttu"
                            width="100%"
                            height="250"
                            frameborder="0"
                            style={{ border: "0;" }}
                            allowfullscreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
